// Define the TCVelikBrowserClient class
class TCVelikBrowserClient {
  constructor(timeout = 5000) {
    // Default timeout for the message response (5 seconds)
    this.timeout = timeout;

    // Track active requests to correlate responses
    this.activeRequests = {};
    this.requestCounter = 0;

    // Initialize the message listener to receive responses
    this.initMessageListener();
  }

  // Initialize the listener for receiving messages from the parent (or iframe)
  initMessageListener() {
    window.addEventListener('message', (event) => {
      const origin = event.origin;

      // TODO: take care of the security later.

      //if (origin !== 'chrome-extension://YOUR_EXTENSION_ID' && origin !== 'https://your-cloud-domain.com') {
      //  console.warn('Received message from untrusted origin:', origin);
      //  return;
      //}

      const data = event.data;

      if (data && data.type === 'responseFromParent' && this.activeRequests[data.requestId]) {
        // Resolve the corresponding promise with the response
        const { resolve } = this.activeRequests[data.requestId];
        resolve(data.response);

        // Clean up the active request
        delete this.activeRequests[data.requestId];
      }
    });
  }

  // Send a message to the parent and return a promise that resolves when the response is received
  sendMessage(message, targetOrigin = '*') {
    return new Promise((resolve, reject) => {
      // Create a unique requestId for tracking the response
      const requestId = `request_${this.requestCounter++}`;

      // Store the resolve and reject functions for later use
      this.activeRequests[requestId] = { resolve, reject };

      // Send the message with the unique requestId
      window.parent.postMessage(
        { ...message, requestId, type: 'requestFromChild' },
        targetOrigin
      );

      // Set a timeout to reject the promise if no response is received in time
      setTimeout(() => {
        if (this.activeRequests[requestId]) {
          reject(new Error('No response received within timeout period'));
          delete this.activeRequests[requestId];
        }
      }, this.timeout);
    });
  }

  // Optionally set a new default timeout for message responses
  setTimeout(newTimeout) {
    this.timeout = newTimeout;
  }
}

export default new TCVelikBrowserClient();
